import { Arrow } from 'component/Carousel/co/Indicators/Arrow'
import { Indicator } from 'component/Carousel/co/Indicators/Indicator'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { times } from 'util/array'

type Props = {
  carousel: CarouselStore
  compact?: boolean
  white?: boolean
}

export const Indicators = observer(({ carousel, compact, white }: Props) => {
  const { items } = carousel

  return <Space height={32} center>
    {!compact && <Arrow carousel={carousel} white={white} left />}
    <Space width={100} center>
      {times(items.length).map(index => (
        <Indicator key={index} carousel={carousel} index={index} white={white} />
      ))}
    </Space>
    {!compact && <Arrow carousel={carousel} white={white} />}
  </Space>
})
